export default "__VITE_ASSET__5e641b0d__"